var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column align-center mb-8 rounded-lg"
  }, [_c('h1', {
    staticClass: "text-h2 text-center primary--text font-weight-bold mb-16"
  }, [_vm._v("Museum Passes")]), _c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "max-width": "850",
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "d-block my-4 mx-auto",
    attrs: {
      "height": "160px",
      "width": "280px",
      "src": "https://media.eipl.org/site/images/tickets/museum-pass-trans.png"
    }
  }), _c('v-card-text', {
    staticClass: "primary--text"
  }, [_c('p', {
    staticClass: "text-body-1 primary--text font-weight-bold mb-8"
  }, [_vm._v(" The Library provides free passes to a variety of museums. All passes may be reserved up to 30 days in advance by East Islip Library cardholders ages 18 and over that hold an unexpired, unblocked card with fines under $10. The passes allow free admission to some of the New York area's most popular attractions. ")]), _c('p', {
    staticClass: "text-body-1 primary--text mb-8"
  }, [_vm._v("Reservations may be made online by following the link below or in person at the Children's Reference Desk.")]), _c('p', {
    staticClass: "text-body-1 primary--text text--lighten-2 font-weight-bold"
  }, [_vm._v("Please remember to check with the museum prior to your visit for days and hours of operation.")])]), _c('v-card-actions', {
    staticClass: "d-flex flex-wrap align-end justify-space-between primary--text text-center pa-4"
  }, [_c('v-btn', {
    staticClass: "mb-4 px-8",
    attrs: {
      "color": "primary",
      "href": "https://www2.museumkey.com/ui/?code=eastny11730",
      "x-large": "",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-bank")]), _vm._v("VIEW ALL PASSES")], 1), _c('v-sheet', {
    staticClass: "d-flex flex-column align-start justify-start mb-4"
  }, [_c('p', {
    staticClass: "primary--text text-center mb-0"
  }, [_vm._v("Also available")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": "",
      "to": "/services/discount-tickets"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-ticket")]), _vm._v("DISCOUNT TICKETS")], 1)], 1)], 1)], 1), _c('v-sheet', {
    staticClass: "my-16",
    attrs: {
      "color": "transparent"
    }
  }), _c('v-sheet', {
    staticClass: "my-16",
    attrs: {
      "color": "transparent"
    }
  }), _c('v-sheet', {
    staticClass: "my-16",
    attrs: {
      "color": "transparent"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }